const removeHttpRegex = /(https|http):\/\//;

export function removeHttpAndSlash(url?: string | null): string {
  let newUrl = url?.replace(removeHttpRegex, '') ?? '';
  if (newUrl.charAt(newUrl.length - 1) === '/') {
    newUrl = newUrl.substring(0, newUrl.length - 1);
  }
  return newUrl;
}
